import { loading, error } from 'State/actions';
import * as types from './types';
import { createToast, toastType } from 'Common/ToastHelper';

export const postImportFile = (file, delimiter) => {
  return async (dispatch, getState, MPWWebApi) => {
    let formData = new FormData();

    formData.append('delimiter', delimiter);
    formData.append('import_file', file);

    dispatch(loading(types.DC_IMPORT_FETCHING, true));
    try {
      const response = await MPWWebApi.importStudentsApi.postImportStudentsFileData(
        formData,
        dispatch
      );
      if (response && response.data.Data.length > 0) {
        dispatch(saveImportFile(response, file.name));
      } else {
        createToast(toastType.error, 'Error', 'File is empty.');
      }
    } catch (err) {
      if (err) {
        dispatch(error(types.DC_IMPORT_FETCH_ERROR, err));
      }
    }
    dispatch(loading(types.DC_IMPORT_FETCHING, false));
  };
};

export const clearImportFile = () => ({
  type: types.DCIMPORT_FILECONFIG_SAVE_FILE,
  payload: { file: { data: { Data: [] } }, name: '' },
});

export const saveImportFile = (file, name) => ({
  type: types.DCIMPORT_FILECONFIG_SAVE_FILE,
  payload: { file, name },
});



// WEBPACK FOOTER //
// ./src/pages/dcimport/state/common/actions.js